import { Filter } from "@/components/filter/_types";
import { Button, ButtonVariant, ButtonColorVariant, ButtonSize } from "@/components/ui/button";
import { RotateCcwIcon, TrashIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

interface PhonebookFiltersProps {
  filters: Filter<unknown, unknown>[];
  filterValues: Record<string, string[]>;
  onFilterChange: (filterId: string, values: string[]) => void;
  onClearAllFilters: () => void;
  onResetAllFilters: () => void;
}

export function PhonebookFilters({
  filters,
  filterValues,
  onFilterChange,
  onClearAllFilters,
  onResetAllFilters,
}: PhonebookFiltersProps) {
  const { t } = useTranslation("phonebook");

  return (
    <div className="space-y-3 pb-4">
      <div className="grid grid-cols-[repeat(auto-fill,minmax(250px,1fr))] gap-4 py-2">
        {filters.map((filter) => (
          <div key={filter.id}>
            {filter.render({
              selectedValues: filterValues[filter.id] || [],
              showBadges: true,
              showRemoveAllButton: false,
              onSelectionChange: (values) => onFilterChange(filter.id, values),
            })}
          </div>
        ))}
      </div>

      <div className="flex justify-end gap-2">
        <Button
          variant={ButtonVariant.Outlined}
          colorVariant={ButtonColorVariant.Secondary}
          size={ButtonSize.Sm}
          onClick={onClearAllFilters}
        >
          <TrashIcon className="mr-2 h-4 w-4" />
          {t("ClearAllFilters")}
        </Button>
        <Button
          variant={ButtonVariant.Outlined}
          colorVariant={ButtonColorVariant.Secondary}
          size={ButtonSize.Sm}
          onClick={onResetAllFilters}
        >
          <RotateCcwIcon className="mr-2 h-4 w-4" />
          {t("ResetAllFilters")}
        </Button>
      </div>
    </div>
  );
}
